// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Nx-z","smallCardRow":"Ox-z","largeCardRow":"Px-z","productSearchRow":"Qx-z","curatedRow":"Rx-z"};